import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { toast } from 'react-toastify'
import { api } from '../../app/Api/ApiSlice'
import StoreFeedCard from '../../components/StoreFeedCard'
import "./storesStyles.css"
import InfiniteScroll from 'react-infinite-scroll-component'

const MyStores = () => {
    const [stores, setStores] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    useEffect(() => {
        fetchShops()
    }, [page])

    const fetchShops = async () => {
        try {
            setIsLoading(true)
            const response = await api.get(`/stores/mystores`, { params: { page } })

            const newStores = response.data?.data || response.data || []

            if (newStores.length === 0) {
                setHasMore(false)
            } else {
                setStores((prev) => [...prev, ...newStores])
            }

        } catch (error) {
            setHasMore(false)
            toast.error(error.response?.data?.message || "Failed to load stores")
        } finally {
            setIsLoading(false)
        }
    }

    const loadMore = () => {
        setPage((prev) => prev + 1)
    }

    return (
        <div className='store-feeds page-body'>
            <div className="stores-page-content">
                <div className="stores-page-header">
                    <h2 className='stores-page-title'>my stores</h2>
                </div>

                <div className="shop-feeds-list">
                    <InfiniteScroll
                        dataLength={stores.length}
                        next={loadMore}
                        hasMore={hasMore}
                        loader={<Loader />}
                        endMessage={<p>No more Businesses available.</p>}
                    >
                        <div className="stores-grid">
                            {
                                stores.map((str, index) => (
                                    <StoreFeedCard key={index} str={str} />
                                ))
                            }
                        </div>
                    </InfiniteScroll>
                </div>
                {isLoading && <Loader />}
            </div>
        </div>
    )
}

export default MyStores
